import "../css/NewPost.css";
import { useFormik } from "formik";
import React, { useRef, useState } from "react";
import { Button } from "primereact/button";
import "../css/VideoImageUploader.css";
import { useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { apiClient } from "../apiClient";
import colors from '../colors';


const token = JSON.parse(localStorage.getItem('userToken'));
const config = { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } };
let user = localStorage.getItem('seo_app')? JSON.parse(localStorage.getItem('seo_app')): { username: "", name: "", avatarPic: "profile-index.png" };

function NewOrder(props) {
    const [uploadFile, setUploadFile] = useState("");
    const [fileType, setFileType] = useState();
    const inputRef = React.useRef();
    const [source, setSource] = useState();
    const [desktop, setDesktop] = useState(window.matchMedia("(min-width: 768px)").matches);
    const [clickedButton, setClickedButton] = useState('');
    const [isHtmlMode, setIsHtmlMode] = useState(false);
    const [htmlContent, setHtmlContent] = useState(""); 
    const navigate = useNavigate();
    const [uploadProgress, setUploadProgress] = useState(0);
    const editorRef = useRef(null);
    const colors = [
        'rgb(0, 0, 0)', 'rgb(230, 0, 0)', 'rgb(255, 153, 0)', 'rgb(255, 255, 0)', 'rgb(0, 138, 0)',
        'rgb(0, 102, 204)', 'rgb(153, 51, 255)', 'rgb(255, 255, 255)', 'rgb(250, 204, 204)',
        'rgb(255, 235, 204)', 'rgb(255, 255, 204)', 'rgb(204, 232, 204)', 'rgb(204, 224, 245)',
        'rgb(235, 214, 255)', 'rgb(187, 187, 187)', 'rgb(240, 102, 102)', 'rgb(255, 194, 102)',
        'rgb(255, 255, 102)', 'rgb(102, 185, 102)', 'rgb(102, 163, 224)', 'rgb(194, 133, 255)',
        'rgb(136, 136, 136)', 'rgb(161, 0, 0)', 'rgb(178, 107, 0)', 'rgb(178, 178, 0)', 'rgb(0, 97, 0)',
        'rgb(0, 71, 178)', 'rgb(107, 36, 178)', 'rgb(68, 68, 68)', 'rgb(92, 0, 0)', 'rgb(102, 61, 0)',
        'rgb(102, 102, 0)', 'rgb(0, 55, 0)', 'rgb(0, 41, 102)', 'rgb(61, 20, 102)'
    ];

    const createColorOptions = (colors) => colors.map(color => (
        <option key={color} value={color} style={{ backgroundColor: color }}></option>
    ));



    const toolbarOptions = (
        <div id="toolbar">
           
            <select className="ql-header" defaultValue="">
                <option value="1">h1</option>
                <option value="2">h2</option>
                <option value="3">h3</option>
                <option value="">p</option>
            </select>
            <button className="ql-bold"></button>
            <button className="ql-code"></button>
            <button className="ql-italic"></button>
            <button className="ql-underline"></button>
            <select className="ql-align">
                <option value="">Left</option>
                <option value="center">Center</option>
                <option value="right">Right</option>
            </select>
            <button className="ql-strike"></button>
            <button className="ql-list" value="ordered"></button>
            <button className="ql-list" value="bullet"></button>
            <button className="ql-link"></button>
            <button className="ql-image"></button>
            <select className="ql-color">{createColorOptions(colors)}</select>
            <select className="ql-background">{createColorOptions(colors)}</select>
        </div>
    );

   


    const formik = useFormik({
        initialValues: {
    
            keyword:""
        },
        validate: (values) => {
            let errors = {};
           
            if (!values.keyword) {
                errors.keyword = "لطفا کلمه کلیدی را وارد کنید";
            }
        
            
            
            
            return errors;
        },
        onSubmit: (values) => {
        
            
                submitPost(uploadFile, values);
                return;
        },
    });

    const isFormFieldValid = (phone) => !!(formik.touched[phone] && formik.errors[phone]);
    const getFormErrorMessage = (phone) => {
        return (
            isFormFieldValid(phone) && (
                <p className="p-error" style={{ textAlign: 'right' }}>{formik.errors[phone]}</p>
            )
        );
    };



    // Submit new post:
    // const submitPost = (uploadFile, values) => {

    //     user = JSON.parse(localStorage.getItem('seo_app'));

    //     var data = {
    //         keyword:values.keyword,
    //         creator:user._id
    //     };

      

    //     apiClient.post(process.env.REACT_APP_BACK + "/orders", data, config);

    //     props.closeDialog();


       
    // }

    const submitPost = (uploadFile, values) => {
        const user = JSON.parse(localStorage.getItem('seo_app'));
        const token = JSON.parse(localStorage.getItem('userToken'));
    
        if (!user || !token) {
            console.error("User or token not found");
            // بهتره ریدایرکت یا پیام خطا بدی
            return;
        }
    
        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        };
    
        const data = {
            keyword: values.keyword,
            creator: user._id
        };
    
        apiClient.post(`${process.env.REACT_APP_BACK}/orders`, data, config)
            .then(() => {



                /*send sms to manager informing about new article ******************************************/
                var d = JSON.stringify({
                            "code": "czbtaaella4shdi",
                            "sender": "+983000505",
                            "recipient": "09352333881",
                            "variable": {
                              "verification-code": 1111
                            }
                          });
      
      
                var config1 = {
                  method: 'post',
                  url: 'https://api2.ippanel.com/api/v1/sms/pattern/normal/send',
                  headers: { 
                    'apikey': 'bv1PxCuaPVZUcIPOSqgmx7u9w8nzdBk1Boj_vnwvo48=', 
                    'Content-Type': 'application/json'
                  },
                  data : d
                };
      
                apiClient(config1)
                .then(function (response) {
                  
                  if(response.status === 200)
                  {
                   
                  }
                  
                })
                .catch(function (error) {
                  console.log("error",error);
                
                });
                /******************************************************************************/ 




                props.closeDialog();


                
            })
            .catch(err => {
                console.error("Error submitting order:", err);
                if (err.response?.status === 401) {
                    // اگر نیاز هست یوزر را sign out کنی یا پیغام بدی
                    localStorage.removeItem('userToken');
                    localStorage.removeItem('seo_app');
                    // navigate("/login"); // یا مشابه آن
                }
            });
    };
    

    return (
        <div id="new_order">
            <form onSubmit={formik.handleSubmit} className="new-post-form">
                <div>
                    <h2 style={{ marginBottom: '50px' }}>سفارش مقاله جدید</h2>

                  
                    <p
                        style={{width: desktop ?'300px' : 'fit-content',direction:'rtl',textAlign: desktop ?'right' : 'center'}}
                    >کلمه کلیدی مورد نظر خود را انتخاب کنید. مقاله ای به همراه تصاویر و لینک های خارجی برای شما تولید خواهد شد. پس از انتشار مقاله، می توانید با تعیین مقاله های مرتبط و کلمه کلیدی فرعی، لینک سازی داخلی هم انجام دهید.</p>

                    {getFormErrorMessage("keyword")}
                    <div style={{ direction: 'rtl', marginBottom: '30px', alignItems: 'center' }}>
                        <span style={{ display: "flex", width: "fit-content" }}>
                             کلمه کلیدی :
                        </span>
                        <InputText
                            style={{ display: "flex", width: "100%" }}
                            id="keyword"
                            name="keyword"
                            placeholder=" کلمه کلیدی ..."
                            value={formik.values.keyword}
                            onChange={formik.handleChange}
                            maxLength={50}
                        />
                    </div>

                   

                  

            




                        
                        <div className="tag-user" style={{ marginTop: "20px", direction: "rtl", textAlign: "right", display: desktop ? "flex" : "block", alignItems: "center" }}>
                           


                            <span style={{ display: "flex", direction: desktop ? 'ltr' : 'rtl', width: desktop ? "100%" : "100%" , marginTop: !desktop ? "20px" : null}}>
                                
                                    <Button id="is-not-uploading"
                                        type="submit"
                                        style={{width:"100%", display:'table'}}
                                        onClick={() => setClickedButton("publish")}
                                        >ثبت سفارش</Button>
                                
                            </span>

                  

                            
                        </div>

                        <div>
                        
                         
                        </div>

                       
                    

                </div>

            </form>


        </div>
    );
}

export default NewOrder;
